import { Outlet } from 'react-router';
import { UserNotActive } from '../../_pages/UserNotActive';
import { useInitialData } from '../../hooks/useInitialData';

export const UserActiveRoute = ({ children }: { children?: React.ReactNode }) => {
    const {
        data: {
            aggregatedUser: { user },
        },
    } = useInitialData();

    if (user?.isNotActive) {
        return <UserNotActive />;
    }

    return children ? <>{children}</> : <Outlet />;
};
